import React, { useRef } from 'react';

import Button from '@atlaskit/button/default/button';
import DropdownMenu from '@atlaskit/dropdown-menu/dropdown-menu';
import DropdownItemGroup from '@atlaskit/dropdown-menu/dropdown-menu-item-group';
import mergeRefs from '@atlaskit/ds-lib/merge-refs';
import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';
import { ModalDropdownItemTrigger } from '@atlassian/entry-points/modal-dropdown-item-trigger';

import { modalEntryPoint } from '../fixtures/modal-entry-point';
import { RelayWrapper } from '../utils/wrapper';

export default function ModalDropdownItemTriggerExample(): React.JSX.Element {
	const menuButtonRef = useRef<HTMLButtonElement>(null);

	return (
		<RelayWrapper>
			<ModalContextProvider>
				<DropdownMenu
					trigger={({ triggerRef, ...triggerProps }) => (
						<Button {...triggerProps} ref={mergeRefs([triggerRef, menuButtonRef])}>
							Actions
						</Button>
					)}
					shouldRenderToParent
				>
					<DropdownItemGroup>
						<ModalDropdownItemTrigger
							entryPoint={modalEntryPoint}
							modalTitle="Example Modal"
							loadingText="Loading example modal"
							modalProps={{ shouldReturnFocus: menuButtonRef }}
							aria-haspopup="dialog"
						>
							Open modal
						</ModalDropdownItemTrigger>
					</DropdownItemGroup>
				</DropdownMenu>
			</ModalContextProvider>
		</RelayWrapper>
	);
}
